<template>
  <a-card :bordered="false">
    <!-- Drawer -->
    <a-drawer
      title="Strategy Set List"
      :width="screenWidth"
      @close="onClose"
      :visible="visible"
    >
      <!-- Drawer contentborder -->
      <div
        :style="{
          padding:'10px',
          border: '1px solid #e9e9e9',
          background: '#fff',
        }">

        <div class="table-page-search-wrapper">
          <a-form layout="inline" :form="form" @keyup.enter.native="searchQuery">
            <a-row :gutter="10">
              <a-col :md="8" :sm="12">
                <a-form-item label="Name">
                  <a-input style="width: 120px;" placeholder="Please enterName" v-model="queryParam.itemText"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="9" :sm="24">
                <a-form-item :label="$t('platformCollection.state')" style="width: 170px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    placeholder="Please select"
                    v-model="queryParam.status"
                  >
                    <a-select-option value="1">Normal</a-select-option>
                    <a-select-option value="0">Disable</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="7" :sm="24">
                <span style="float: left;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery">Search</a-button>
                  <a-button type="primary" @click="searchReset" style="margin-left: 8px">Reset</a-button>
                </span>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="2" :sm="24">
                <a-button style="margin-bottom: 10px" type="primary" @click="handleAdd">Add</a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div>
          <a-table
            ref="table"
            rowKey="id"
            size="middle"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            bordered
            @change="handleTableChange"
          >

            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">Edit</a>
              <a-divider type="vertical"/>
              <a-popconfirm title="ConfirmDelete??" @confirm="() => handleDelete(record.id)">
                <a>Delete</a>
              </a-popconfirm>
            </span>

          </a-table>
        </div>
      </div>
    </a-drawer>
    <AppStrategyidAdd ref="modalForm" @ok="modalFormOk"></AppStrategyidAdd>
  </a-card>
</template>

<script>
import pick from 'lodash/pick'
import { getDictItem, deleteDictItem, getAppStrategyidList, addAppStrategyid} from '@/webpublicapi/system'
import { filterObj } from '@/utils/util'
import AppStrategyidAdd from './AppStrategyidAdd'

export default {
  name: 'DictItemList',
  components: { AppStrategyidAdd },
  data () {
    return {
      // Pagination params
      ipagination: {
        current: 1,
        pageSize: 30,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' Total ' + total + ' records'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      dataSource: [],
      loading: false,
      columns: [
        {
          title: 'StrategyID',
          align: 'center',
          dataIndex: 'strategyid'
        },
        {
          title: 'Assign Ratio',
          align: 'center',
          dataIndex: 'scale'
        },
        {
          title: 'Type',
          align: 'center',
          dataIndex: 'type'
        },
        {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      queryParam: {
        appSsid:'',
        dictId: '',
        dictName: '',
        itemText: '',
        status: "1"
      },
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      title: 'Action',
      visible: false,
      screenWidth: 800,
      model: {},
      dictId: '',
      appSsid:'',
      status: '1',
      labelCol: {
        xs: { span: 5 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 12 }
      },
      form: this.$form.createForm(this),
      validatorRules: {
        itemText: { rules: [{ required: true, message: 'Please enterName!' }] },
        itemValue: { rules: [{ required: true, message: 'Please enterDataValue!' }] }
      }
    }
  },
  created () {
    // When page initializes,Set drawer width based on screen size
    this.resetScreenSize()
  },
  methods: {
    searchQuery () {
      this.loadData(1)
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      that.queryParam.dictName = ''
      that.queryParam.dictCode = ''
      that.loadData(this.ipagination.current)
    },
    loadData (arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.ipagination.current = 1
      }
       this.loading = true
       var params = this.getQueryParams()// Query conditions
      getAppStrategyidList(Object.assign({},params)).then((res)=>{
        if(res.code===1000){
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        }else{
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
      })
    },
    handleTableChange (pagination, filters, sorter) {
      // TODO Filter
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      }
      this.ipagination = pagination
      this.loadData()
    },
    add (dictId) {
      this.dictId = dictId
      this.edit({})
    },
    edit (record) {
      console.dir(record)
      if (record.id) {
        this.appSsid = record.appSsid
      }
      this.queryParam = {}
      this.form.resetFields()
      this.model = Object.assign({}, record)
      // this.model.dictId = this.dictId
      this.queryParam.appSsid = this.appSsid
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model))
      })
      // When other modules call this module,Call this method to load dictionary data
      this.loadData()
    },

    getQueryParams () {
      var param = Object.assign({}, this.queryParam)
      param.pageNum = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      return filterObj(param)
    },

    // Add dictionary data
    handleAdd () {
      this.$refs.modalForm.add(this.dictId)
      this.$refs.modalForm.title = 'Add'
    },
    handleEdit (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = 'Edit'
    },
    handleDelete(id){
      deleteDictItem({id}).then((res) => {
        if (res.code === 1000) {
          that.$message.success(res.msg)
          this.loadData()
        } else {
          that.$message.warning(res.msg)
        }
      })
    },
    showDrawer () {
      this.visible = true
    },
    onClose () {
      this.visible = false
      this.form.resetFields()
      this.dataSource = []
    },
    // Drawer width changes with screen size
    resetScreenSize () {
      const screenWidth = document.body.clientWidth
      if (screenWidth < 600) {
        this.screenWidth = screenWidth
      } else {
        this.screenWidth = 600
      }
    },
    // modelCallback
    modalFormOk () {
      this.loadData()
    }
  }
}
</script>
<style scoped>

</style>
